import { put, takeLatest, all, call } from 'redux-saga/effects';
import { setAction, updatePlanAction, getPlansAction } from '../actions/plansPage';
import sagaMiddleware from '../../../middleware/middleware';
import { getSummaryAction } from '../../BillingPage/actions/billingPage';
import Helpers from '../../../utils/Helpers';
import actionTypes from '../../../redux/actions/action-types';
import paymentProvider from '../../../utils/paymentProvider';
import {
  getTeamPlansWithTeamid,
  postTeamSubscribeUsingTeamidAndPlanid,
  postTeamSubscriptionCancelPendingUsingTeamid,
  getTeamBillingAccountidWithTeamid,
  getBillingPlans,
  getCouponWithCouponcode
} from '../../../api/cloudApiGenerated';
import { useCaptcha } from 'utils/SignupHelpers';
import config from './../../../config';

export function* getAccountId(params) {
  let { team } = params.data;

  try {
    let data = yield call(getTeamBillingAccountidWithTeamid, team.id);
    yield put(
      setAction({
        accountId: data.account_id
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading account ID: ' + error.message.join(' ')
      })
    );
  }
}

export function* getPlans(params) {
  try {
    let data = yield call(getBillingPlans);
    data.plans = data.plans.sort((a, b) => a.id > b.id);
    yield put(
      setAction({
        plansData: data
      })
    );
  } catch (error) {
    yield put(
      setAction({
        error: 'loading plans: ' + error.message.join(' ')
      })
    );
  }
}

export function* getTeamPlans(params) {
  let { team, coupon_code } = params.data;
  try {
    let data = yield call(getTeamPlansWithTeamid, team.id);
    data.data = data.data.sort((a, b) => a.id - b.id);
    yield put(
      setAction({
        plans: data.data
      })
    );

    if (coupon_code) {
      try {
        let couponData = yield call(getCouponWithCouponcode, coupon_code);
        yield put(
          setAction({
            modalIsOpen: true,
            modalPlanCode: couponData.data[0].planDetails[0].id,
            modalPending: false,
            activeSubscription: couponData.data[0].planDetails[0],
            activeCoupon: couponData.data[0],
            page: 0
          })
        );
      } catch (e) {
        throw e;
      }
    }
  } catch (error) {
    yield put(
      setAction({
        error: 'loading plans: ' + error.message.join(' ')
      })
    );
  }
}

export function* deletePlan(params) {
  let { team, reloadSubscription } = params.data;
  yield put(
    setAction({
      modalPlanCode: 1,
      activeCoupon: {}
    })
  );

  yield put(
    updatePlanAction({
      team,
      activeCoupon: {},
      reloadSubscription
    })
  );
}

export function* updatePlan(params) {
  let { team, activeCoupon, modalPlanCode, subscription, reloadSubscription, modalPending, three_d_secure_token } =
    params.data;
  let body = {
    coupon_code: activeCoupon.coupon_code
  };

  yield put(
    setAction({
      loading: true
    })
  );

  if (three_d_secure_token) {
    body.three_d_secure_token = three_d_secure_token;
  }

  const action = 'subscription';
  const token = yield call(useCaptcha, config, action);

  body.captchaResponse = token;
  body.action = action;

  const getAJAX = function () {
    return modalPending
      ? postTeamSubscriptionCancelPendingUsingTeamid(team.id, body)
      : postTeamSubscribeUsingTeamidAndPlanid(team.id, modalPlanCode, body);
  };

  let hasError = false;
  try {
    yield call(getAJAX);
    if (reloadSubscription) reloadSubscription(team);
    yield put(getPlansAction());
    yield put(getSummaryAction({ team }));
    yield put(
      setAction({
        activeSubCoupon: subscription ? subscription.coupon_details : null,
        loading: false
      })
    );
    hasError = false;
  } catch (error) {
    hasError = true;
    if (Helpers.isStr(error)) {
      yield put(
        setAction({
          error: 'subcribing to plan: ' + error,
          loading: false
        })
      );
    } else {
      if (error?.response?.three_d_secure) {
        paymentProvider.setup3dSecure(error.response.three_d_secure, null, function (three_d_token, token_id) {
          sagaMiddleware.run(updatePlan, {
            data: {
              ...params.data,
              three_d_secure_token: three_d_token
            }
          });
        });
        return;
      }
      yield put(
        setAction({
          error: 'subcribing to plan: ' + (Helpers.isArr(error.message) ? error.message.join(' ') : error.message),
          loading: false
        })
      );
    }
  }

  if (!hasError) {
    //Show thank you message
    yield put(
      setAction({
        multipleModalPage: 2,
        loading: false
      })
    );
  }
}

export function* getCoupon(params) {
  let { coupon, coupons, activeSubscription, plans } = params.data;

  try {
    let data = yield call(getCouponWithCouponcode, coupon);
    if (data.data && data.data.length > 0) {
      let activeCoupon = coupons;

      activeCoupon = data.data[0];
      const validPlans = activeCoupon.plan_codes;

      if (
        validPlans.some((element) => {
          return element === activeSubscription.provider_id;
        })
      ) {
        yield put(
          setAction({
            activeCoupon,
            disableConfirmPlanBtn: false
          })
        );
      } else {
        // Not a valid plan for the coupon.
        let plansArr = [];
        plans.forEach((plan) => {
          if (validPlans.includes(plan.provider_id)) {
            plansArr.push(plan.name);
          }
        });
        yield put(
          setAction({
            couponError: 'This coupon can only be used with the plan(s): ' + plansArr.join(',')
          })
        );
        /*
        setTimeout(() => {
          yield put(setAction({
            couponError: ''
          }))
        }, 5000)*/
      }
    }
  } catch (e) {}
}

/** Watch functions */
export function* watchGetAccountId() {
  yield takeLatest(actionTypes.plansPage.getAccountId, getAccountId);
}
export function* watchGetTeamPlans() {
  yield takeLatest(actionTypes.plansPage.getTeamPlans, getTeamPlans);
}
export function* watchGetPlans() {
  yield takeLatest(actionTypes.plansPage.getPlans, getPlans);
}
export function* watchGetCoupon() {
  yield takeLatest(actionTypes.plansPage.getCoupon, getCoupon);
}
export function* watchDeletePlan() {
  yield takeLatest(actionTypes.plansPage.deletePlan, deletePlan);
}
export function* watchUpdatePlan() {
  yield takeLatest(actionTypes.plansPage.updatePlan, updatePlan);
}

export default function* rootSaga() {
  yield all([
    watchGetAccountId(),
    watchGetTeamPlans(),
    watchGetPlans(),
    watchGetCoupon(),
    watchDeletePlan(),
    watchUpdatePlan()
  ]);
}
